import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef } from 'react';
import { Box, HStack, useToken } from '@chakra-ui/react';
import { hasValue, useT } from '@progress-fe/core';
import { Tooltip } from 'react-tooltip';
import { chakraComponents, Select as ChakraSelect } from 'chakra-react-select';
import { Svg } from '../../base';
const SelectFC = ({ wide, name, value, options, size = 'sm', placeholder, isDisabled, inPortal, tooltipMaxWidth = 280, optionTooltip, optionTooltipMaxWidth = 280, tooltipStrategy, isInvalid, onChange }) => {
    const tooltipId = useRef(`SELECT_TOOLTIP_${new Date().toISOString()}`);
    const { t } = useT();
    const [borderHex] = useToken('colors', ['border']);
    const chakraStyles = {
        container: (provided, state) => ({
            ...provided,
            minH: '24px',
            h: '24px',
            opacity: state.isDisabled ? '0.6' : '1',
            w: wide ? '100%' : 'auto'
        }),
        control: (provided) => ({
            ...provided,
            minH: '24px',
            h: '24px',
            boxShadow: 'shadow_5',
            bg: 'buttonBg !important',
            _hover: {
                bg: 'buttonBg',
                cursor: 'pointer'
            }
        }),
        valueContainer: (provided) => ({
            ...provided,
            fontSize: '12px',
            p: '0 2px'
        }),
        inputContainer: (provided) => ({
            ...provided,
            p: 0
        }),
        placeholder: (provided) => ({
            ...provided,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis'
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            p: 0,
            m: 0,
            w: '28px',
            color: 'contrastIcon'
        }),
        menu: (provided) => ({
            ...provided,
            m: 0,
            p: '1px 0',
            zIndex: 3
        }),
        menuList: (provided) => ({
            ...provided,
            p: '2px',
            border: 'none',
            bg: 'buttonBg'
        }),
        option: (provided, state) => {
            const data = state.data;
            return {
                ...provided,
                display: 'block',
                p: '3px 6px',
                fontSize: '12px',
                borderRadius: '4px',
                bg: state.isSelected ? 'accent !important' : 'buttonBg',
                color: state.isSelected ? 'white' : 'bodyText',
                wordWrap: 'break-word',
                maxW: '100%',
                opacity: data.readonly ? '0.5' : '1',
                pointerEvents: data.readonly ? 'none' : 'all',
                _hover: {
                    bg: state.isSelected ? 'accent !important' : 'accentLight'
                }
            };
        }
    };
    const noOptionsMessage = () => _jsx(Box, { fontSize: "11px", children: t('common.empty') });
    return (_jsxs(_Fragment, { children: [_jsx(ChakraSelect, { components: {
                    SingleValue: (props) => {
                        return (_jsx(chakraComponents.SingleValue, { ...props, children: _jsxs(HStack, { gap: "6px", minW: "0", "data-tooltip-id": tooltipId.current, children: [value?.icon && (_jsx(Box, { ml: '4px', w: '12px', children: _jsx(Svg, { name: value.icon, size: "s12" }) })), _jsx(Box, { className: "cut-text", children: value?.label ?? placeholder })] }) }));
                    },
                    Option: (props) => {
                        const data = props.data;
                        const tooltipId = `${name}_${data.value}`;
                        return (_jsxs(chakraComponents.Option, { ...props, children: [_jsxs(HStack, { gap: "6px", minW: "0", "data-tooltip-id": tooltipId, children: [data.icon && (_jsx(Box, { w: '12px', children: _jsx(Svg, { name: data.icon, size: "s12" }) })), _jsx(Box, { className: "cut-text", children: data.label })] }), _jsx(Tooltip, { id: tooltipId, delayShow: 150, place: 'bottom', border: `1px solid ${borderHex}`, closeEvents: { click: true, mouseleave: true }, hidden: !optionTooltip, style: {
                                        padding: '0',
                                        backgroundColor: 'white',
                                        maxWidth: `${optionTooltipMaxWidth}px`,
                                        textWrap: 'wrap',
                                        width: 'fit-content',
                                        zIndex: 3
                                    }, opacity: "1", children: _jsx(Box, { color: "bodyText", p: "6px 10px", fontSize: "12px", children: data.label }) })] }));
                    }
                }, menuPortalTarget: inPortal ? document.body : undefined, useBasicStyles: true, isSearchable: false, isDisabled: isDisabled ?? false, size: size, name: name, options: options, noOptionsMessage: noOptionsMessage, closeMenuOnSelect: true, placeholder: placeholder, value: value ?? null, chakraStyles: chakraStyles, isInvalid: isInvalid, 
                // @ts-ignore
                onChange: onChange }), _jsx(Tooltip, { id: tooltipId.current, delayShow: 150, place: 'bottom', border: `1px solid ${borderHex}`, hidden: !hasValue(value), closeEvents: { click: true, mouseleave: true }, positionStrategy: tooltipStrategy, style: {
                    padding: '0',
                    backgroundColor: 'white',
                    maxWidth: `${tooltipMaxWidth}px`,
                    textWrap: 'wrap',
                    width: 'fit-content',
                    zIndex: 3
                }, opacity: "1", children: _jsx(Box, { color: "bodyText", p: "6px 10px", fontSize: "12px", children: value?.label }) })] }));
};
export const Select = SelectFC;
//# sourceMappingURL=Select.js.map